var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08725 14.4267C1.65369 13.376 0.687248 11.9893 0.187919 10.2667H1.44966C1.93289 11.6373 2.77584 12.7307 3.97315 13.5573C5.17047 14.384 6.49664 14.8 7.94631 14.8C9.86309 14.8 11.4792 14.144 12.8054 12.8267C14.1315 11.5093 14.7919 9.904 14.7919 8C14.7919 6.096 14.1315 4.49067 12.8054 3.17333C11.4792 1.856 9.86309 1.2 7.94631 1.2C6.58792 1.2 5.38523 1.53067 4.33289 2.18667C3.29127 2.84267 2.44295 3.71733 1.79866 4.8H6.04027V6.02667H0V0H1.20805V3.54667C1.97584 2.44267 2.93154 1.57867 4.0698 0.944C5.20805 0.309333 6.49664 0 7.94631 0C10.1852 0 12.0859 0.778667 13.6483 2.336C15.2107 3.89333 16 5.776 16 8C16 10.224 15.2161 12.112 13.6483 13.664C12.0805 15.216 10.1852 16 7.94631 16C6.13691 16 4.52081 15.4773 3.08725 14.4267Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon_reset.a88c9ab7.svg";
export { ForwardRef as ReactComponent };